const config = {
    build_number: '601289',
    build_timestamp: '2025-05-01T21:40:44.212Z',
    build_commit: '89d9a37b7682dd3d9b2ecee587e4d2b5590b5912',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
